import styled from "styled-components";
import { Button } from "../../atoms/Button";
import { CardTemplate } from "../../templates/CardTemplate";
import { useSmsRegistrationComplete } from "./hook";

export const SmsRegistrationCompletePage: React.FC = () => {
  const { isActivation, handleSmsRegistrationComplete } =
    useSmsRegistrationComplete();

  return (
    <CardTemplate title="SMS認証完了">
      <StyledTextContainer>
        {isActivation
          ? "SMS認証が完了しました。下部ボタンよりログイン画面へ遷移し、ログインを行ってください。"
          : "SMS認証が完了しました。続けて、ログインが簡単に行えるパスキー設定へお進みください。"}
      </StyledTextContainer>

      <Button
        text={isActivation ? "ログインへ" : "次へ"}
        variant="filled"
        onClick={handleSmsRegistrationComplete}
        fullWidth
      />
    </CardTemplate>
  );
};

const StyledTextContainer = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
`;
